<ng-container *ngIf="!stripeIsPresent()">
  <ng-content></ng-content>
</ng-container>
